import type { TFunction } from 'i18next';
import { type Column } from 'design-system-web';
import { simpleDate } from 'lane-shared/helpers/formatters';
import type { InspectionTemplate } from 'inspection-types';

export type TemplateLibraryTableRow = {
  id: string;
  name: string;
  lastUpdated: string | null;
  version: number;
  sectionsCount: number;
  questionsCount: number;
};

export function mapTemplateToTableRow(
  template: InspectionTemplate
): TemplateLibraryTableRow {
  return {
    id: template.id,
    name: template.metadata.name,
    lastUpdated: template.metadata.updatedAt ?? null,
    version: template.version,
    sectionsCount: template.sections.length,
    questionsCount: template.sections.reduce(
      (total, section) => total + section.items.length,
      0
    ),
  };
}

export function getTemplateLibraryColumns(
  t: TFunction
): Column<TemplateLibraryTableRow>[] {
  return [
    {
      header: t('web.admin.inspections.templateLibrary.columns.name'),
      key: 'name',
      type: 'text',
    },
    {
      header: t('web.admin.inspections.templateLibrary.columns.lastUpdated'),
      key: 'lastUpdated',
      renderCell: (value: string | null) =>
        value ? simpleDate(value) : t('punctuation.dash'),
    },
    {
      header: t('web.admin.inspections.templateLibrary.columns.version'),
      key: 'version',
      type: 'text',
      disableSorting: true,
    },
    {
      header: t('web.admin.inspections.templateLibrary.columns.sections'),
      key: 'sectionsCount',
      type: 'text',
    },
    {
      header: t('web.admin.inspections.templateLibrary.columns.questions'),
      key: 'questionsCount',
      type: 'text',
    },
  ];
}

export function getTemplateLibraryRowActions(t: TFunction) {
  return [
    {
      label: t('web.admin.inspections.templateLibrary.actions.customize'),
      onClick: (_row: TemplateLibraryTableRow) => {
        // No-op: customization page is not yet implemented (TS-35737)
      },
    },
    {
      label: '',
      onClick: (_row: TemplateLibraryTableRow) => {},
      isHidden: true,
    },
  ];
}
